import { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useCurrentUserRole } from '../../hooks/useCurrentUserRole';
import { hasRoleLevel, RoleLevel } from '../../utils/roles';
import { Spinner } from '../../ui/Spinner';

type Props = {
  /** The lowest role level allowed in: 'manager' also lets admins in. */
  level: Exclude<RoleLevel, 'employee'>;
  children: ReactNode;
  redirectTo?: string;
};

/**
 * Sends signed-in users without the required role away from a route.
 * Role levels and the roles in each live in utils/roles.
 */
export function RequireRole({ level, children, redirectTo = '/' }: Props) {
  const { level: userLevel, isLoading } = useCurrentUserRole();

  if (isLoading) {
    return (
      <div className="flex h-[75vh] items-center justify-center">
        <Spinner size={10} className="text-red-500" />
      </div>
    );
  }

  if (!hasRoleLevel(userLevel, level)) {
    return <Navigate to={redirectTo} replace />;
  }

  return <>{children}</>;
}
